<div [ngClass]="{'sidebars': sidebars}" class="card-header d-flex justify-content-between align-items-center">
    <ul class="nav nav-tabs card-header-tabs">
        <li *ngFor="let tab of tabs; let i = index" class="nav-item">
            <button class="nav-link" [class.active]="tab.active" (click)="selectTab(i)">
                {{ tab.tabTitle }}
            </button>
        </li>
    </ul>

    <div ngbDropdown class="d-inline-block">
        <button *ngIf="activeTab?.showEditButton" type="button" class="btn-table-dropdown" ngbDropdownToggle>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                <path
                    d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
            </svg>
        </button>
        <div ngbDropdownMenu>
            <button (click)="onEditButtonClick()" ngbDropdownItem>Wijzig</button>
            <button (click)="onDeleteButtonlick()" ngbDropdownItem>Verwijder</button>
        </div>
    </div>

    <button *ngIf="activeTab?.showAddButton" (click)="onAddButtonClick()" class="btn btn-primary">
        Toevoegen
    </button>

    <button *ngIf="activeTab?.showSaveButton" (click)="onSaveButtonClick()" class="btn btn-primary">
        Opslaan
    </button>
</div>
<ng-content></ng-content>